import type { Character, Guild } from '@guildrise/shared';
import { useEffect, useRef, useState } from 'react';
import { ArenaScreen } from './arena-screen.js';
import './arena-entry.css';

export function ArenaEntry({
  catalog,
  guild,
  frameArt,
}: {
  readonly catalog: readonly Character[];
  readonly guild: Guild;
  readonly frameArt?: string | undefined;
}) {
  const [entered, setEntered] = useState(false);
  const video = useRef<HTMLVideoElement>(null);
  useEffect(() => {
    if (entered) return;
    const element = video.current;
    if (!element) return;
    const reduced = window.matchMedia('(prefers-reduced-motion: reduce)');
    let inView = true;
    const update = () => {
      if (reduced.matches || document.hidden || !inView) element.pause();
      else
        void element.play().catch(() => {
          /* Poster remains visible if autoplay is blocked. */
        });
    };
    reduced.addEventListener('change', update);
    document.addEventListener('visibilitychange', update);
    const observer = new IntersectionObserver((entries) => {
      inView = entries.some((entry) => entry.isIntersecting);
      update();
    });
    observer.observe(element);
    update();
    return () => {
      element.pause();
      observer.disconnect();
      reduced.removeEventListener('change', update);
      document.removeEventListener('visibilitychange', update);
    };
  }, [entered]);
  if (entered)
    return (
      <ArenaScreen
        catalog={catalog}
        guild={guild}
        frameArt={frameArt}
        onExit={() => setEntered(false)}
      />
    );
  return (
    <button
      type="button"
      className="arena-entry"
      aria-label="Войти в Арену"
      onClick={() => setEntered(true)}
    >
      <img src="/art/arena-gojo-poster-960.webp" width={960} height={540} alt="" />
      <video
        ref={video}
        src="/art/arena-gojo-640-v2.mp4"
        poster="/art/arena-gojo-poster-960.webp"
        muted
        loop
        playsInline
        preload="metadata"
        tabIndex={-1}
        aria-hidden="true"
      />
      <span className="arena-entry__caption">Арена</span>
    </button>
  );
}
